import { gql } from 'apollo-angular';

export const PROFILE_SETTINGS_MUTATION = gql`
  mutation UpdateProfileSettings($jobTitle: String!) {
    updateProfile(updateProfileRequest: { jobTitle: $jobTitle }) {
      data {
        jobTitle
        __typename
      }
      isSuccess
      message
      errorCode
      __typename
    }
  }
`;
